import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';


interface HeadersComponentProps {
	headers: string;
	label?: string;
	onHeadersChange: (values: string) => void;
	mode: ControlMode;
}

interface HeadersComponentState {
	currentHeaderName: string;
	currentHeaderValue: string;
	values: string[][];

}

interface SingleHeaderProps {
	title: string;
	header: string;
	onChange: (title: string, body: string) => void;
	onDelete: () => void;
	mode: ControlMode;
}

interface SingleHeaderState {
	title: string;
	body: string;
}

class SingleHeaderComponent extends React.Component<SingleHeaderProps, SingleHeaderState>{

	constructor(props) {
		super(props);

		this.state = {
			title: '',
			body: ''
		}
	}

	public componentDidMount() {
		this.setState({ title: this.props.title, body: this.props.header });
	}

	render() {
		return (<Row gutter={24}>
			<Col xs={6}>
				<TextView
					label=''
					mode={this.props.mode}
					value={this.state.title}
					onChanged={(e) => {
						this.setState({ title: e }, () => {

							this.props.onChange(this.state.title, this.state.body);
						});

					}}

				/>
			</Col>
			<Col xs={16}>
				<TextView
					label=''
					mode={this.props.mode}
					value={this.state.body}
					onChanged={(e) => {
						this.setState({ body: e }, () => {

							this.props.onChange(this.state.title, this.state.body);
						});
					}}

				/>
			</Col>
			<Col xs={2}>
				<Button disabled={this.props.mode == 'display'} icon='delete' onClick={() => {
					this.props.onDelete();
				}} />
			</Col>
			</Row>)
	}

}

@observer
export class HeadersComponent extends React.Component<HeadersComponentProps, HeadersComponentState> {
	constructor(props) {
		super(props);

		this.state = {
			currentHeaderName: '',
			currentHeaderValue: '',
			values: []
		}
	}

	public componentDidMount() {
		this.setState({ values: this.props.headers ? this.decoupleValues(this.props.headers) : []})
	}

	encodeValues(values: string[][]) {
		return values.map((tuple, index) => tuple.join(":")).join("\r\n");
	}

	@autobind
	async encodeAndNotify(): Promise<any>  {
		
		this.props.onHeadersChange(this.encodeValues(this.state.values));

		this.setState({values: [...this.state.values]})
	}

	decoupleValues(values: string) {
		return values.split("\r\n").map((item, index) => item.split(':'));
	}

	render() {
		
		
		return (
			<React.Fragment>
				<h4>{this.props.label}</h4>
				{this.state.values.map((tuple, index) => {
					return (<Row key={'header_' + index} gutter={24} style={{margin: '3px'}}>
						<SingleHeaderComponent mode={this.props.mode} title={tuple[0]} header={tuple[1]}
							onChange={(title, body) => {
								this.state.values[index] = [title, body];
								this.encodeAndNotify();
							}}
							onDelete={() => {
								this.state.values.splice(index);
								this.encodeAndNotify();
							}}
						/>
						</Row>)
				})}

				<Button disabled={this.props.mode == 'display'} onClick={() => {
					this.setState({ values: [...this.state.values, ['', '']] });
				}} icon='plus'></Button>
			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/executors/parts/headers-component.tsx